const PHRASE = "30+ ways to start earning online";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <span key={i} className="flex items-center">
        <span className="px-5 text-xs font-semibold uppercase tracking-[0.2em] text-white sm:text-[0.8rem]">{PHRASE}</span>
        <span className="h-1.5 w-1.5 rounded-full bg-[var(--blush-deep)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="sticky top-0 z-50 overflow-hidden bg-[var(--mauve)] py-2.5" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
